import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import Introduction from './Introduction/Introduction.js';
import { getThemeBasicData } from '../../services/Theme.js';
// import Economics from './EconomicsOfCinema/Economics.js';
import General from './General/General.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import Basic from './General/Basic.js';
import Preface from './Introduction/Preface.js';
import Establishment from './Introduction/Establishment.js';
// import Education from './Introduction/Education.js';
// import TeachingInfra from './Introduction/TeachingInfra.js';
// import Screenings from '../Films/EconomicsOfCinema/Screenings.js';
// import Awards from '../Films/EconomicsOfCinema/Awards.js';
import { useSelector } from 'react-redux';
import Sections from '../../CommonComponents/Sections.js';
import MyAccordionNested from '../../components/MyAccordionNested.js';
import Teams from './Introduction/Teams.js';
import ResearchCentre from '../../FunctionalComponents/ResearchCentre/ResearchCentre.js';
import Library from '../../FunctionalComponents/ResearchCentre/Library.js';
import Archive from '../../FunctionalComponents/ResearchCentre/Archive.js';
// import Highlights from './Introduction/Highlights.js';
// import FlipBook from '../FlipBooks/FlipBook.js';
// import { DataNotFound } from '../../CommonComponents/DataNotFound.js';
// import IntegratedTimeline from './IntegratedTimeline/IntegratedTimeline.js';
// import BodyOfWork from './BodyOfWork/BodyOfWork.js';
// import Exhibitions from './BodyOfWork/Exhibitions.js';

const EditThemeObjectRecord = () => {

  const { alias } = useParams();
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const personalityType = pathParts?.[1];
  // const isPhotographer = personalityType.includes('photographer');
  const navigate = useNavigate();
  const [filmTitle, setFilmTitle] = useState();
  const previewEnabled = useSelector(state => state.preview.isEnabled);
  // const isArtist = masterlistType?.includes('Artist');
  const tabs = useMemo(() => {
    let initialTabs = [
      {
        id: "general", title: "General", Component: General,
        subTabs: [
          { id: "primary", title: "Primary", Component: Basic },
          { id: "sections", title: "Sections", Component: Sections },
        ]
      },
      {
        id: "introduction", title: "Introduction", Component: Introduction,
        subTabs: [
          { id: "preface", title: "Preface", Component: Preface },
          { id: "establishment", title: "Establishment", Component: Establishment },
          { id: "team", title: "Team", Component: Teams },
          //Todo: Need to add highlights when data is finalized
          // { id: "highlights", title: "Highlights", Component: Highlights },
        ]
      },
      {
        id:"research-centre", title: "Research Centre", Component: ResearchCentre,
        subTabs: [
          { id: "library", title: "Library", Component: Library },
          { id: "archive", title: "Archive", Component: Archive },
        ]
      },
      // {
      //   id: "economics-of-cinema", title: "Economics of Cinema", Component: Economics,
      //   subTabs: [
      //     { id: "screenings", title: "Screenings", Component: Screenings },
      //     { id: "awards-honours", title: "Awards and Honours", Component: Awards },
      //   ]
      // },
      // {
      //   id: "integrated-timeline", title: "Integrated Timeline", Component: IntegratedTimeline,
      // }
    ];

    // if (isPhotographer) {
    //   initialTabs = initialTabs.concat({
    //     id: "body-of-work", title: "Body Of Work", Component: null, subTabs: [
    //       { id: "photographs-publications", title: "Photographs Publications", Component: DataNotFound },
    //       { id: "flip-book", title: "Flip Books", Component: FlipBook },
    //     ],
    //   });
    // }

    // if (isArtist) {
    //   initialTabs = initialTabs.concat({
    //     id: "body-of-work", title: "Body Of Work", Component: BodyOfWork,
    //     subTabs: [
    //       { id: "exhibitions", title: "Exhibitions", Component: Exhibitions },
    //     ],
    //   });
    //   initialTabs = initialTabs.filter(tab => tab.id !== "economics-of-cinema");
    //   initialTabs = initialTabs.concat({
    //     id: "economics-of-arts", title: "Economics of Arts", Component: Economics,
    //     subTabs: [
    //       { id: "awards-honours", title: "Awards and Honours", Component: Awards },
    //     ],
    //   });
    // }
    return initialTabs;
  }, []);


  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getThemeBasicData(alias);

          if (result) {
            setFilmTitle(result?.full_name);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/${personalityType}/${alias}/${tabs[0].id}/${tabs[0].subTabs[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs, pathParts, personalityType]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
    <Box>
      <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{filmTitle}</Text>
    </Box>
      {previewEnabled ?
        <MyAccordionNested orientation="vertical" list={tabs} urlBasePath={`/${personalityType}`} tabSegmentPosition={2} subTabSegmentPosition={3} /> :
        <MyTabsNested orientation="vertical" list={tabs} urlBasePath={`/${personalityType}`} tabSegmentPosition={2} subTabSegmentPosition={3} />}
    </Stack>
  );
};

export default EditThemeObjectRecord;